import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import ProfilPublik from "./pages/Publik/ProfilPublik";
import { AuthProvider, useAuth } from "./context/AuthContext";

const RotateOverlay = () => (
  <div className="rotate-overlay">
    <div className="phone-icon"></div>
    <h2>Putar Layar Anda</h2>
    <p>Untuk pengalaman terbaik, silakan putar perangkat Anda ke mode landscape (horizontal)</p>
    <div className="arrow-icon">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  </div>
);

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '14px', color: '#666' }}>Memuat...</div>;
  return user ? children : <Navigate to="/admin" replace />;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<><RotateOverlay /><LandingPage /></>} />
        <Route path="/perusahaan/:companyId" element={<ProfilPublik />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </div>
  );
}

export default App;
